/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { htmlSafe } from '@ember/template';
import { getPasswordScore } from 'cio/utils/password-scores';

interface PasswordStrengthCheckerArgs {
  hasError: boolean;
  error: string;
  suggestions: string[];
  passwordScore: number;
  validationTask: any;
}

export default class PasswordStrengthChecker extends Component<PasswordStrengthCheckerArgs> {
  get htmlSafeError() {
    return htmlSafe(this.args.error);
  }

  get passwordScoreUI() {
    return getPasswordScore(this.args.passwordScore);
  }

  get labelText() {
    return this.passwordScoreUI.label;
  }

  get labelClass() {
    return this.passwordScoreUI.labelClass;
  }
}
